import React, { Component } from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import CashOutDollarsRequestModal from "../availableHours/RateAgnosticHourUtilizationRequestModal";
import { getTotalValueAvailable } from "../../../apis/revshare/AvailableHoursApi";
import { connect } from "react-redux";

class TotalAvailableRevSharePanel extends Component {
  render() {
    return (
      <Card className="total-balance-card popout-element">
        <Card.Body>
          <Row className="align-items-center">
            <Col>
              <span className="available-hours-total-balance">
                Total {this.props.profile.isAdmin && !this.props.profile.ghost ? "Outstanding" : ""} Balance: $
                {this.state.loading ? (
                  <Spinner animation="border" size="sm" style={{ marginLeft: "10px", marginRight: "10px" }} />
                ) : (
                  this.state.totalBalance.toFixed(2)
                )}
              </span>
            </Col>
            {(this.props.profile.isAdmin && !this.props.profile.ghost) || this.props.blackedOut ? null : (
              <Col xs="auto">
                <CashOutDollarsRequestModal requestableDollars={this.state.totalBalance} />
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      totalBalance: 0.0,
    };
  }

  componentDidMount() {
    getTotalValueAvailable(this.props.profile.isAdmin, this.props.profile.ghost).then((total) =>
      this.setState({
        loading: false,
        totalBalance: total,
      })
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    blackedOut: state.blackoutPeriod,
    profile: state.profile,
  };
}

export default connect(mapStateToProps)(TotalAvailableRevSharePanel);
